import classNames from 'classnames';
import OptionsGroup, { OptionsGroupProps } from 'compositions/OptionsGroup';
import Text from 'components/ui/Text';
import { FC } from 'react';
import { NextArray } from 'type';

export type SidebarProps = {
  title: string;
  optionsGroups: NextArray<OptionsGroupProps>;
  className?: string;
};

const Sidebar: FC<SidebarProps> = ({ title, optionsGroups, className }) => {
  // const [isHovering, setIsHovering] = useState<boolean>(false);
  const classes = classNames(
    'absolute inset-0 flex flex-col justify-center h-full overflow-y-auto',
    'px-6 md:px-8  py-8',
    className,
    // isHovering ? 'overflow-clip' : 'overflow-y-auto',
  );

  return (
    <div className={classes}>
      <Text
        bold
        center
        elementType="div"
        color="grey-500"
        className="small-caps"
      >
        {title}
      </Text>

      {optionsGroups.map(({ _key, ...props }) => (
        <OptionsGroup key={_key} {...props} />
      ))}
    </div>
  );
};

export default Sidebar;
